import { useState, useMemo, useCallback } from 'react';
import { errorMessage } from '../models/Errors';

export const isNullOrEmpty = (str: string | undefined | null) => {
    return !str || str?.trim().length === 0;
};
export function useErrorHandler() {
    const [errors, setErrors] = useState <errorMessage[]>([]);

    const handleError = useCallback((error: errorMessage) => {
        setErrors(prev => [...prev, error]);
    }, []);

    const clearErrors = useCallback(() => setErrors([]), []);

    const hasErrors = useMemo(() => errors.length !== 0, [errors]);



    // Validation helpers that automatically handle errors
    const validateRequired = useCallback((value: string | undefined | null, fieldName: string, ifErrMsg: string): boolean => {
        if (isNullOrEmpty(value)) {
            handleError({
                code: fieldName,
                message: `${fieldName} is required`,
                details: ifErrMsg
            });
            return false;
        }
        return true;
    }, [handleError]);

    const validateEmail = useCallback((email: string): boolean => {
        if (isNullOrEmpty(email)) {
            handleError({ code: 'Email', message: 'Email is required', details:'' });
            return false;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            handleError({ code: "Email", message: 'Invalid email address', details: 'Please enter a valid email address.' });
            return false;
        }

        return true;
    }, [handleError]);

    return { errors, handleError, hasErrors, clearErrors, validateRequired, validateEmail };
}